import styled from "styled-components";

export const NavDiv = styled.div`
  display: flex;

  .container {
    display: flex;
    justify-content: center;
    .store-div {
      display: flex;
      justify-content: flex-end;
      margin-left: 30px;
    }
  }
  .nv {
    /* background-color:red; */
    p {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      margin: 0px 10px;
      font-feature-settings: "liga" off;
      color: #18191f;
    }
    p:hover {
      color: #1e90ff;
    }
  }

  .navbar {
    position: absolute;
  }

  .navbar-nav .nav-item .nav-link {
    font-family: Gilroy;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    margin: 0px 10px;
    font-feature-settings: "liga" off;
    color: #18191f;

    img {
      width: 100px;
    }
  }
  .navbar-nav .nav-item .nav-link:hover {
    color: #1e90ff;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    border-top: 3px solid #1e90ff;
    background: #1dcdfe;
  }
  .dropdown-item:hover {
    background-color: #1e90ff;
    color: #fff;
  }
  nav {
    -webkit-transition: padding-top 0.3s, padding-bottom 0.3s;
    -moz-transition: padding-top 0.3s, padding-bottom 0.3s;
    transition: padding-top 0.3s, padding-bottom 0.3s;
    border: none;
  }

  @media (max-width: 540px) {
    .navbar-nav {
      background-color: #fff;
      /* background-color: black; */
      border-top: 3px solid #1e90ff;
      color: #fff;
      z-index: 1;
    }
    .navbar-nav .nav-item .nav-link {
      padding: 0.7em 1em !important;
      font-size: 100%;
      font-weight: 500;
    }
    .banner-text {
      padding: 150px 0 150px 0;
    }
  }

  @media (min-width: 1024px) {
    .navbar-nav {
      color: #fff;
      z-index: 1;
    }
    .navbar-nav .nav-item .nav-link {
      padding: 0.7em 1em !important;
      font-size: 100%;
      font-weight: 500;
    }

    .container {
      margin: 0px 55px;

      .pic {
        display: none;
      }
    }
  }

  @media (min-width: 768px) {
    .navbar-nav {
      color: #fff;
      z-index: 1;
    }
    .navbar-nav .nav-item .nav-link {
      padding: 0.7em 1em !important;
      font-size: 100%;
      font-weight: 500;
    }

    .container {
      margin: 0px 30px;

      .pic {
        display: none;
      }
    }
  }
`;
